var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.58862 0 0 3.58862 0 8C0 12.4114 3.58862 16 8 16C12.4114 16 16 12.4114 16 8C16 3.58862 12.4114 0 8 0Z",
    fill: "#ed6265"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99 8.00019L10.8462 6.14401C11.0513 5.93892 11.0513 5.60642 10.8462 5.40165L10.5987 5.1542C10.3936 4.94905 10.0611 4.94905 9.85631 5.1542L8.00019 7.01032L6.14401 5.15382C5.93892 4.94873 5.60642 4.94873 5.40165 5.15382L5.15382 5.40127C4.94873 5.60642 4.94873 5.93892 5.15382 6.14369L7.01032 8.00019L5.1542 9.85631C4.94905 10.0615 4.94905 10.394 5.1542 10.5987L5.40165 10.8462C5.60674 11.0513 5.93924 11.0513 6.14401 10.8462L8.00019 8.99L9.85631 10.8462C10.0615 11.0513 10.394 11.0513 10.5987 10.8462L10.8462 10.5987C11.0513 10.3936 11.0513 10.0611 10.8462 9.85631L8.99 8.00019Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconError);
export default __webpack_public_path__ + "static/media/icon_error.b6d31914.svg";
export { ForwardRef as ReactComponent };